import React from 'react'

const Facts = ({data}) => {
    return (
        <div className="container-xxl py-5">
            <div className="container">
                <div
                    className="text-center mx-auto wow fadeInUp"
                    data-wow-delay="0.1s"
                    style={{
                        maxWidth: 500,
                        visibility: "visible",
                        animationDelay: "0.1s",
                        animationName: "fadeInUp"
                    }}
                >
                    <p className="text-primary text-uppercase mb-2">Why Choose Us!</p>
                    <h1 className="display-6 mb-5">
                    Premium Photography with a Personal Touch
                    </h1>
                </div>
                <div className="row g-3">
                    <div
                        className="col-lg-4 col-md-6 pt-lg-5 wow fadeInUp"
                        data-wow-delay="0.1s"
                        style={{
                            visibility: "visible",
                            animationDelay: "0.1s",
                            animationName: "fadeInUp"
                        }}
                    >
                        <div className="fact-item bg-light text-center h-100 p-5">
                            <h1 className="display-2 text-primary mb-3" data-toggle="counter-up">
                                5+
                            </h1>
                            <h4 className="mb-3">States Capturing Cultures</h4>
                            <span>
                            Experienced Across 5+ States, we’ve captured diverse cultures, traditions, and celebrations. Our photography adapts to every style, making each story uniquely beautiful.
                            </span>
                        </div>
                    </div>
                    <div
                        className="col-lg-4 col-md-6 wow fadeInUp"
                        data-wow-delay="0.3s"
                        style={{
                            visibility: "visible",
                            animationDelay: "0.3s",
                            animationName: "fadeInUp"
                        }}
                    >
                        <div className="fact-item bg-light text-center h-100 p-5">
                            <h1 className="display-2 text-primary mb-3" data-toggle="counter-up">
                                8+
                            </h1>
                            <h4 className="mb-3">Years Experience</h4>
                            <span>
                            We specialize in capturing unforgettable moments through pre-wedding, wedding, and suit photography. Our creative team turns your special memories into timeless stories.
                            </span>
                        </div>
                    </div>
                    <div
                        className="col-lg-4 col-md-6 pt-lg-5 wow fadeInUp"
                        data-wow-delay="0.5s"
                        style={{
                            visibility: "visible",
                            animationDelay: "0.5s",
                            animationName: "fadeInUp"
                        }}
                    >
                        <div className="fact-item bg-light text-center h-100 p-5">
                            <h1 className="display-2 text-primary mb-3" data-toggle="counter-up">
                                75+
                            </h1>
                            <h4 className="mb-3">Happy Clients</h4>
                            <span>
                            We’ve built a reputation for delivering beautiful, heartfelt photography. Every shoot reflects our commitment to quality, creativity, and client satisfaction.
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    )
}

export default Facts
